import React from "react";
import PropTypes from "prop-types";
import ReactAudioPlayer from "react-audio-player";

const AudioPlayer = ({ src }) => {
  return <ReactAudioPlayer src={src} controls style={{ width: "100%" }} />;
};

export default AudioPlayer;

AudioPlayer.propTypes = {
  /**
   * The source of the audio file
   */
  src: PropTypes.string
};
